import { render, staticRenderFns } from "./wiki_header.vue?vue&type=template&id=cc6bcab4&vue3"
import script from "./wiki_header.vue?vue&type=script&lang=js&vue3"
export * from "./wiki_header.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports